import { Axios } from '@src/app/context/Api/includes/Axios';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';

/**
 * GetActionPathInitiatives
 *
 * Retrieves statistic counts for action path initiatives from the remote API via an authenticated request.
 *
 * @param payload
 * @returns {Promise<any>}
 * @constructor
 */
export const GetActionPathInitiatives = async (payload = {}) => {
  try {
    const theApiKey = payload?.[0];
    const theQueryKey = payload?.[1];
    const thePayload = payload?.[2] || {};

    const requestArgs = {
      baseURL: config('API_URL'),
      headers: {
        'x-api-endpoint': `/dashboard/actionPath/initiative/${thePayload.initiativeType}`,
      },
      method: 'GET',
      params: { apiKey: theApiKey, queryKey: theQueryKey },
    };

    const remoteResponse = await Axios.request(requestArgs);
    return remoteResponse.data;
  } catch (error) {
    logger.error(
      'src/entities/ActionPath/api/requests/queries/GetActionPathInitiatives.js -> GetActionPathInitiatives()',
      false,
      error
    );

    throw error;
  }
};
